import { createAction } from '@reduxjs/toolkit';

export const ON_INVITE_ACTION_TYPE = 'saga/onInvite';
export const onInviteAction = createAction(ON_INVITE_ACTION_TYPE);
